// src/LocationMap.js
import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Circle, useMap } from 'react-leaflet';
import L from 'leaflet';
import { Popup } from 'react-leaflet';
// import PropTypes from 'prop-types';

// Fixing the default icon issue in Leaflet when using webpack
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const FitBounds = ({ locations }) => {
    const map = useMap();
  
    useEffect(() => {
      if (locations.length > 0) {
        const bounds = locations.map(location => [location.latitude, location.longitude]);
        map.fitBounds(bounds);
      }
    }, [locations, map]);
  
    return null;
};

const LocationMap = ({ locations, radius }) => {
    if (!locations?.length) return null;
  
    const mapStyle = { height: '100%', width: '100%' };
  
    return (
      <MapContainer style={mapStyle} zoom={15} scrollWheelZoom={true}>
        <FitBounds locations={locations} />
        <TileLayer
          attribution=""
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
  
        {locations.map((location, index) => (
          <React.Fragment key={index}>
            <Marker position={[location.latitude, location.longitude]}>
              <Popup>
                {location.type === 'checkin' 
                  ? 'Posizione di Entrata' 
                  : location.type === 'checkout' 
                    ? 'Posizione di Uscita' 
                    : 'Posizione'}
              </Popup>
            </Marker>

            {radius && (
              <Circle
                center={[location.latitude, location.longitude]}
                radius={radius}
                color="blue"
                fillColor="blue"
                fillOpacity={0.2}
              />
            )}

            {location.accuracy && !radius && (
              <Circle
                center={[location.latitude, location.longitude]}
                radius={location.accuracy}
                color="blue"
                fillColor="blue"
                fillOpacity={0.1}
              />
            )}
          </React.Fragment>
        ))}
      </MapContainer>
    );
  };
  
  export default LocationMap;


//   <div className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-gray-600 font-normal text-md">
//   Posizione non registrata
// </div>